'use strict';

function normalizeLashbrookUUID(value) {
    if (!value) {
        return null;
    }

    return String(value).trim().toLowerCase();
}

function getWishlistStateKey(pid, lashbrookUUID) {
    var normalizedPid = pid ? String(pid).trim() : null;
    var normalizedUuid = normalizeLashbrookUUID(lashbrookUUID);

    if (!normalizedPid) {
        return null;
    }

    return normalizedUuid ? normalizedPid + '::' + normalizedUuid : normalizedPid;
}

function hasWishlistKeys() {
    return !!(window && window.UncachedData && Array.isArray(window.UncachedData.wishlistKeys));
}

function getWishlistStateKeys() {
    if (!window || !window.UncachedData) {
        return new Set();
    }

    if (hasWishlistKeys()) {
        return new Set(window.UncachedData.wishlistKeys);
    }

    if (Array.isArray(window.UncachedData.wishlistPIDs)) {
        return new Set(window.UncachedData.wishlistPIDs);
    }

    return new Set();
}

function persistWishlistStateKeys(wishlistKeys) {
    if (!window || !window.UncachedData) {
        return;
    }

    window.UncachedData.wishlistKeys = Array.from(wishlistKeys);
    window.UncachedData.wishlistPIDs = Array.from(wishlistKeys)
        .map(function (key) {
            return String(key).split('::')[0];
        })
        .filter(function (pid, index, pids) {
            return pid && pids.indexOf(pid) === index;
        });
}

function getLinkWishlistStateKey($wishlistLink) {
    return getWishlistStateKey(
        $wishlistLink.attr('data-wishlistpid'),
        $wishlistLink.attr('data-lashbrook-uuid')
    );
}

function shouldSuppressLegacyLashbrookPdpWishlistState($wishlistLink, isInWishlist) {
    if (!isInWishlist || !$wishlistLink || !$wishlistLink.length) {
        return false;
    }

    if (hasWishlistKeys()) {
        return false;
    }

    var $productDetail = $wishlistLink.closest('.product-detail');
    if (!$productDetail.length) {
        return false;
    }

    var productBrand = $productDetail.data('brand') || '';
    var lashbrookUUID = $wishlistLink.attr('data-lashbrook-uuid') || '';

    return String(productBrand).toLowerCase() === 'lashbrook' && !String(lashbrookUUID).trim();
}

// TODO: REVISIT ON IF THIS SHOULD BE DONE SERVER SIDE
/**
 * update window product list experience data
 * @param {string} data - data returned from the server's ajax call
 */
 var updateUncachedData = function(data) {
    var wishlistKeys = getWishlistStateKeys();
    var updatedKey = getWishlistStateKey(data.pid, data.lashbrookUUID);

    if (data.actionType === 'change') {
        var newKey = getWishlistStateKey(data.pidUpdated, data.lashbrookUUIDUpdated || data.lashbrookUUID);
        if (updatedKey) {
            wishlistKeys.delete(updatedKey);
        }
        if (newKey) {
            wishlistKeys.add(newKey);
        }
    } else if (data.actionType === 'add') {
        if (updatedKey) {
            wishlistKeys.add(updatedKey);
        }
    } else if (data.actionType === 'remove') {
        if (updatedKey) {
            wishlistKeys.delete(updatedKey);
        }
    }
    persistWishlistStateKeys(wishlistKeys);
};

/**
 * update clicked links attributes and text
 * @param {Object} specificLinks - jQuery object representing selection of product list experience links
 */
var updateLinkData = function(specificLinks, data) {
    if (!window || !window.UncachedData) {
        return;
    }
    var wishlistLinks = specificLinks || $('[data-wishlistpid]');
    if (!wishlistLinks || !wishlistLinks.length) {
        return;
    }
    var wishlistKeys = getWishlistStateKeys();
    wishlistLinks.each((_i, wishlistLink) => {
        var $wishlistLink = $(wishlistLink);
        var wishlistKey = getLinkWishlistStateKey($wishlistLink);
        if (wishlistKey) {
            var isInWishlist = wishlistKeys.has(wishlistKey);

            if (shouldSuppressLegacyLashbrookPdpWishlistState($wishlistLink, isInWishlist)) {
                isInWishlist = false;
            }

            $wishlistLink.attr('data-inwishlist', isInWishlist);
            if (isInWishlist) {
                $wishlistLink.attr('title', $wishlistLink.attr('data-removemessage'));
                if ($wishlistLink.data('includetext') === true) {
                    $wishlistLink.find('span').html($wishlistLink.attr('data-removemessage'));
                }
            } else {
                $wishlistLink.attr('title', $wishlistLink.attr('data-addmessage'));
                if ($wishlistLink.data('includeicon') === true) {
                    $wishlistLink.find('span').html($wishlistLink.attr('data-addmessage'));
                }
            }
            var icon = $wishlistLink.find('.wishlist-icon');
            if (icon && icon.length) {
                $(icon).toggleClass('selected', isInWishlist);
            }
            if (data && data.wishlistQuantities) {
                $wishlistLink
                    .attr('data-wishlistquantity', data.wishlistQuantities)
                    .data('wishlistquantity', data.wishlistQuantities);
            } else {
                $wishlistLink
                    .attr('data-wishlistquantity', 1)
                    .data('wishlistquantity', 1);
            }
        }
    });
};

var openToast = (data) => {
    if (data.pid) {
        $('.wishlist-toast').trigger('show', function($toast) {

            if (data.wishlistName) {
                $toast.find('.wishlist-name').html(data.wishlistName);
            } else {
                $toast.find('.wishlist-name').html($toast.data().defaultWishlistName);
            }

            $toast
                .find('.message .manage')
                .attr('href', data.wishlistUrl);

            if (data.manageLabel) {
                $toast.find('.message .manage').html(data.manageLabel);
            } else {
                $toast.find('.message .manage').html($toast.data().defaultManageLabelWishlist);
            }

            $toast
                .attr({
                    'data-product-id': data.pid,
                    'data-wishlist-id': data.wishlistId,
                    'data-lashbrook-uuid': data.lashbrookUUID || data.lashbrookUuid || ''
                })
                .data('product-id', data.pid)
                .data('wishlist-id', data.wishlistId)
                .data('lashbrook-uuid', data.lashbrookUUID || data.lashbrookUuid || '');

            if (data.wishlistQuantities) {
                $toast
                    .attr('data-wishlist-quantities', data.wishlistQuantities)
                    .data('wishlist-quantities', data.wishlistQuantities);
            }

            if (data.productOptions) {
                $toast
                    .attr({
                        'data-product-options': data.productOptions
                    })
                    .data('product-options', data.productOptions);
            }

            if (data.wishlistActionType === 'add') {
                $toast.find('.message.remove, .message.both').addClass('d-none');
                $toast.find('.message.add').removeClass('d-none');
            } else if (data.wishlistActionType === 'remove') {
                $toast.find('.message.remove').removeClass('d-none');
                $toast.find('.message.add, .message.both').addClass('d-none');
            } else {
                $toast.find('.message.both').removeClass('d-none');
                $toast.find('.message.add, .message.remove').addClass('d-none');
            }
        });
    }
};

var getUrlParam = (paramName) => {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName);
}

module.exports = {
    openToast: openToast,
    updateLinkData: updateLinkData,
    updateUncachedData: updateUncachedData,
    getUrlParam: getUrlParam
};
